import { Head, useForm } from "@inertiajs/react";
import { SubmitEvent } from "react";
import {
  ManagerBlogFormData,
  ManagerBlogsFormProps,
} from "@/types/manager_blogs";
import BlogForm from "./_form";

export default function NewBlog({
  blog,
  paths,
  limits,
  errors,
}: ManagerBlogsFormProps) {
  const { data, setData, post, processing } = useForm<ManagerBlogFormData>({
    blog,
  });

  const handleSubmit = (e: SubmitEvent) => {
    e.preventDefault();
    post(paths.submit);
  };

  return (
    <div className="flex">
      <Head title="New Post" />
      <div className="grow">
        <div style={{ padding: "20px", maxWidth: "1100px", margin: "0 auto" }}>
          <BlogForm
            data={data}
            setData={setData}
            onSubmit={handleSubmit}
            processing={processing}
            errors={errors}
            paths={paths}
            limits={limits}
            title="New Post"
            submitLabel="Create Post"
          />
        </div>
      </div>
    </div>
  );
}
